import InMemoryTable from 'libs/kd_data_table/in-memory-table';
export default class PaymentHistoryVM extends InMemoryTable {
  constructor(charges, profile) {
    console.log('Initializing PaymentHistoryVM');

    let options = {
      dataset_name: 'charges',
      table_properties: {
        name: 'PaymentHistoryTable',
        creatable: { enabled: false },
        paginatable: { enabled: true },
        searchable: { enabled: true }
      },
      column_properties: {
        hideable: { enabled: false },
        sortable: { enabled: false },
        editable: { enabled: false }
      },
      columns: [
        {
          property: 'created_at',
          prettyName: 'Date',
          width: 'date_short',
          sortable: { type: 'date' }
        },
        {
          property: 'detail',
          prettyName: 'Description',
          width: 'name',
          sortable: { type: 'string' }
        },
        {
          property: 'formatted_amount',
          prettyName: 'Total',
          width: 'percent',
          sortable: { type: 'string' }
        },
        {
          property: 'invoice',
          prettyName: 'View',
          width: 'number_short',
          sortable: { enabled: false }
        }
      ],
      row_properties: {
        removable: { enabled: false },
        draggable: {
          enabled: false
        }
      }
    };

    if (profile().shop_customer.subscription && profile().shop_customer.subscription.canceled_at) {
      charges.unshift({
        created_at: profile().shop_customer.subscription.canceled_at(),
        canceled: true,
        active_until: profile().shop_customer.subscription.subscription_end_date(),
        detail: `Membership Canceled (active until ${profile().shop_customer.subscription.subscription_end_date()})`,
        failed: false
      });
    }

    const el = document.getElementById('js-payment-history-table');
    const data = {
      charges: ko.mapping.fromJS(charges),
      first_page: true,
      last_page: false,
      total_charges: charges.length
    };

    super(data, el, options);
  }

  anyChargesFailed(){
    const hasFailed = _.find(this.rows(), function(charge) {
      return charge.failed();
    });
    return !!hasFailed;
  }
}

